module.exports = __webpack_public_path__ + "static/media/chat.9cc26808.svg";